import PropTypes from "prop-types"
import React from "react"

import {
  ButtonLink,
  FormContainer,
  FormTitle,
  FormWrapper,
  InputWrapper,
  TitleContainer,
  Text,
} from "areas/order/components"

const CompletedRequest = ({ rmaType }) => {
  return (
    <FormContainer>
      <FormWrapper>
        <TitleContainer>
          <FormTitle>Request Submitted.</FormTitle>
        </TitleContainer>
        <Text mb={3}>
          Thank you. Your {rmaType} request has been submitted
          {rmaType !== "resizing" &&
            " and will take 1-2 business days to process"}
          . We will send you further instructions via email.
        </Text>

        <InputWrapper>
          <ButtonLink
            data-cy="payments-continue-shopping-btn"
            data-lc="completed-request"
            to="/"
          >
            Continue Shopping
          </ButtonLink>
        </InputWrapper>
      </FormWrapper>
    </FormContainer>
  )
}

CompletedRequest.propTypes = {
  rmaType: PropTypes.string,
}

export default CompletedRequest
